import { render, staticRenderFns } from "./ExchangeReports.vue?vue&type=template&id=055d3352&"
import script from "./ExchangeReports.vue?vue&type=script&lang=js&"
export * from "./ExchangeReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports